import {NewMarkdownViewer} from '@github-ui/markdown-viewer/NewMarkdownViewer'
import {ActionList, NavList, SplitPageLayout} from '@primer/react'
import {ArtifactsBlankSlate} from './ArtifactsBlankSlate'
import {useSelectedPullRequestArtifact} from './use-selected-pull-request-artifact'
import styles from './ArtifactsContent.module.css'

export const ArtifactsContent = () => {
  // TODO: Announce loading, error, empty, and artifact selection changes to screen readers.
  const {artifacts, isPending, isLoadingError, selectedArtifact, setSelectedNumber} = useSelectedPullRequestArtifact()
  if (isPending) return <ArtifactsBlankSlate heading="Loading artifacts…" />
  if (isLoadingError) return <ArtifactsBlankSlate heading="Unable to load artifacts" />

  if (artifacts.length === 0) {
    return (
      <ArtifactsBlankSlate
        heading="No artifacts yet"
        description="Artifacts created for this pull request will appear here"
      />
    )
  }

  return (
    <SplitPageLayout>
      <SplitPageLayout.Pane position="start" sticky={false} padding="condensed">
        <NavList aria-label="Artifacts">
          <NavList.Heading as="h2">Artifacts</NavList.Heading>
          {artifacts.map(artifact => (
            <ActionList.Item
              key={artifact.id}
              onSelect={() => setSelectedNumber(artifact.number)}
              active={selectedArtifact?.id === artifact.id}
              aria-current={selectedArtifact?.id === artifact.id ? true : undefined}
            >
              <span className={styles.ArtifactName}>{artifact.name}</span>
            </ActionList.Item>
          ))}
        </NavList>
      </SplitPageLayout.Pane>
      <SplitPageLayout.Content as="div" width="full">
        {selectedArtifact ? (
          <section aria-labelledby="selected-artifact-heading" className={styles.Artifact}>
            <h2 id="selected-artifact-heading" className={styles.Heading}>
              {selectedArtifact.name}
            </h2>
            <NewMarkdownViewer key={selectedArtifact.id} verifiedHTML={selectedArtifact.body} />
          </section>
        ) : (
          <ArtifactsBlankSlate heading="Artifact not found" description="Select an artifact from the sidebar" />
        )}
      </SplitPageLayout.Content>
    </SplitPageLayout>
  )
}
